<template>
  <div class="w-full h-full flex">
    <div class="settlement-network-box h-full box-border p-4">
      <div class="card h-full box-border bg-white shadow-theme">
        <div class="card-body">
          <ul class="mb-4 border-b border-solid" style="border-color: #e7e9eb">
            <router-link
              v-for="menu in menus"
              tag="li"
              :to="menu.path"
              :key="menu.meta.id"
              class="cursor-pointer leading-22 text-theme-black-650 text-medium inline-block px-6 py-3"
            >
              {{ menu.meta.label }}
            </router-link>
          </ul>

          <div class="main-box w-full pl-4 pr-4 box-border" style="height: calc(100% - 29px); overflow: auto">
            <router-view></router-view>
          </div>
        </div>
      </div>
      <ToNewSettlementDialog ref="settlementDialog"></ToNewSettlementDialog>
    </div>
    <!-- 右半部分 -->
    <el-scrollbar wrapClass="overflow-x-hidden" class="w-290px">
      <el-card class="border-0 rounded-none h-full overflow-auto" shadow="never">
        <div class="title text-medium-x leading-22 font-semibold pl-6 pr-4 pt-6 pb-2 text-theme-black-850">线上结算</div>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850" v-if="settlementType !== 99">
          <span v-custom="'out_D74'">调研工厂</span>已开通线上结算服务，助您一键结算面对面访问、电话调查、明察暗访的调查员、代理费用。
          <span class="cursor-pointer text-theme" @click="newVersion">了解详情</span>
        </p>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850" v-if="settlementType !== 99">
          开通线上结算服务后，您可使用线上结算，<span v-custom="'out_D74'">调研工厂</span>将按调查员到手金额的 {{getAccountingRateVal('6.5%～7.5%【具体服务费费率请与客服联系】')}}
          收取费用，用于调查员代缴税及平台技术服务费。同时，为您的总花费金额开具 6%
          的增值税专用发票或普通发票。
        </p>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850" v-if="settlementType === 99">
          <span v-custom="'out_D74'">调研工厂</span>助您一键结算面对面访问、电话调查、明察暗访的调查员、代理费用。
        </p>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850" v-if="settlementType === 99">
          您可使用线上结算，<span v-custom="'out_D74'">调研工厂</span>将按调查员到手金额的 {{getAccountingRateVal('6.5%～7.5%【具体服务费费率请与客服联系】')}}
          收取费用，用于调查员代缴税及平台技术服务费。同时，为您的总花费金额开具 6% 的增值税专用发票或普通发票。
        </p>
        <img
          class="w-full px-6 mb-2 box-border cursor-pointer"
          src="/assets/img/settlement/protocol-intro.png"
          @click="showImage = true"
        />
        <!-- 查看大图 -->
        <ElImageViewer
          v-if="showImage"
          :initialIndex="0"
          :on-close="
            () => {
              showImage = false
            }
          "
          :url-list="imageUrl"
          :z-index="5000"
        />
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850" v-if="settlementType !== 99">
          如您对线上结算服务感兴趣，或有任何疑问，请微信扫码联系客服
        </p>
        <ContactInformation class="ml-6 mr-4 mb-6" v-if="settlementType !== 99" />
        <div class="md:w-auto h-px bg-border-gray ml-6 mr-4"></div>

        <AccountCalculator title="线上结算费用计算器" :text="accCalcText" :ratio="accountingRate" />
      </el-card>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ElImageViewer from 'dygc-ui/packages/image/src/image-viewer'
import ContactInformation from '@/components/base/ContactInformation'
import AccountCalculator from '@/components/base/AccountCalculator.vue'
import ToNewSettlementDialog from '@/views/survey/settlement/components/ToNewSettlementDialog'
export default {
  name: '',
  components: { ToNewSettlementDialog, ContactInformation, AccountCalculator, ElImageViewer },
  data() {
    return {
      menus: null,
      showImage: false,
      imageUrl: ['assets/img/settlement/protocol-intro.png']
    }
  },
  computed: {
    ...mapGetters(['settlementType', 'configContextMap']),
    accountingRate() {
      const { accountingRate = 0 } = this.$store.getters || {}
      return accountingRate || 0
    },
    accCalcText() {
      const pexText = this.accountingRate === null || this.accountingRate === 0 ? '（以 6.5% 为例）' : ''
      return `若使用线上结算，${this.configContextMap.get("survey")?.out_D74 || '调研工厂'}将按调查员到手金额的 ${this.getAccountingRateVal('6.5%-7.5%')} 收取服务费，用于调查员代缴税及平台技术服务费。您可使用下方计算器计算调查员到手金额或调查费用预算${pexText}。`
    },
  },
  created() {
    this.menus = this.$dygcRouter.getChildrenByName('settlement-network')
  },
  mounted() {
    this.$refs.settlementDialog.openDialog()
  },
  methods: {
    newVersion() {
      this.$router.push({ name: 'cost-settlement' })
    },
    getAccountingRateVal(defaultVal = '6.5%') {
      return this.accountingRate === null || this.accountingRate === 0 ? defaultVal : `${this.accountingRate}%`
    }
  }
}
</script>

<style lang="scss" scoped>
.settlement-network-box {
  width: calc(100% - 290px);
  .router-link-active {
    @apply text-theme border-theme border-b-2 border-solid;
  }

  .card .card-body {
    height: calc(100% - 50px);
  }
}
::v-deep .el-card__body {
  @apply p-0 h-full;
}
.title::before {
  content: '';
  @apply bg-theme block float-left w-1 h-5 -ml-6;
}
::v-deep .el-scrollbar__view {
  @apply h-full;
}
::v-deep .item-container {
  .el-card {
    @apply mb-0;
  }
}
::v-deep .contact-information {
  @apply text-small text-theme-black-850;
  .sub-title {
    @apply text-theme-black-450 ml-3 leading-22;
  }
}
</style>
